import React from 'react';

import {
  ContentGroup,
  Grid,
  GridItem,
  Heading,
  Hr,
  Main,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { InfoPanel } from 'client/components/infoPanel';
import MetaTags from 'client/components/metaTags/MetaTags';
import { StyledLink } from 'client/components/styledLink/StyledLink';

import { SubmittingLimitedCompanyMortgageApplicationContent } from './SubmittingLimitedCompanyMortgageApplication.config';

function SubmittingLimitedCompanyMortgageApplicationPage(): React.JSX.Element {
  const { metaContent, pageTitle, backButtonHref, backButtonLabel, infoPanel } =
    useContent<SubmittingLimitedCompanyMortgageApplicationContent>();
  return (
    <Main>
      <MetaTags metaContent={metaContent} />
      <ContentGroup>
        <Hr marginTop="none" />
        <StyledLink
          iconPosition="left"
          data-testid="back-button-link"
          to={backButtonHref}
        >
          {backButtonLabel}
        </StyledLink>
        <Heading as="h1" size="s7" marginTop="05">
          {pageTitle}
        </Heading>
        <Hr />
        <Grid>
          <GridItem sm={12} md={8}>
            <InfoPanel
              infoPanel={infoPanel}
              pageTestIds={{
                sectionHeading:
                  'submitting-ltd-company-mortgage-application-page-heading',
                sectionBody:
                  'submitting-ltd-company-mortgage-application-page-body',
              }}
            />
          </GridItem>
        </Grid>
      </ContentGroup>
    </Main>
  );
}

export default SubmittingLimitedCompanyMortgageApplicationPage;
